<template>
<div>
  <b-container>
    <b-card header="News and Updates" header-bg-variant="primary"
    border-variant="primary">
      <b-list-group
        id="news-and-updates-table"
        v-for="post in listPerPage"
        :key="post.id"
      >
        <b-link
          :href="getURL(post.link)"
          target="_blank"
          style="text-decoration: none;">
        <b-list-group-item button class="list-btn">
          <strong class="mb-1" v-html="post.title.rendered"></strong>
          <br>
          <small>{{getDate(post.date_gmt)}}</small>
        </b-list-group-item>
        </b-link>
      </b-list-group>
      <br>
      <b-pagination
        size="sm"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="news-and-updates-table"
      ></b-pagination>
    </b-card>
  </b-container>
</div>
</template>
<script>
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      error: null,
      perPage: 3,
      currentPage: 1,
      listPerPage: [],
    };
  },
  computed: {
    // Gets the posts that are in the store
    ...mapState({
      dataPortalPosts: (state) => state.dataPortalPosts,
    }),
    rows() {
      return this.dataPortalPosts.length;
    },
  },
  mounted() {
    this.filterList();
  },
  watch: {
    currentPage() {
      this.filterList();
    },
  },
  methods: {
    // Splits the listing of posts into groupings of 3 per page
    filterList() {
      const indexStart = (this.currentPage - 1) * this.perPage;
      const indexEnd = this.perPage * this.currentPage;
      this.listPerPage = this.dataPortalPosts.slice(indexStart, indexEnd);
    },
    getURL(url) {
      return url;
    },
    // To display a timeframe from today
    getDate(date) {
      return moment.utc(date).fromNow();
    },
    // To get the id of the clicked element for GA
    getStoryID(event) {
      this.$ga('event', event.target.id);
    },
  },
};
</script>
<style scoped>
.card-header {
  color: #f2f2f2;
  font-weight: bold;
}
.card-body {
  background-color: #383838;
}
.list-btn {
  /* background-color: #878787; */
  background-color: #383838;
  color: #f2f2f2;
  border-color: #878787;
}
.list-btn:hover {
  background-color: #3995a3;
  color: #f2f2f2;
}
</style>
